export class ShippingTracking {
  constructor() {
    this.setEvents();
  }

  setEvents() {
    const button = document.querySelector("#wvp-tracking-save");

    if (button) {
      button.addEventListener("click", (e) => {
        e.preventDefault();

        const code = document.querySelector("#wvp-tracking-code");
        const url = document.querySelector("#wvp-tracking-url");
        const post = document.querySelector("#wvp-tracking-post");

        if (code && post) {
          this.saveTrackingCode(code.value, url.value, post.value);
        }
      });
    }
  }

  saveTrackingCode(code, url, post) {
    const loader = document.querySelector(".wvp-tracking");
    loader?.classList.remove("wvp-tracking-hidden");

    const body = new FormData();

    body.append("action", "save_tracking_code");
    body.append("code", code);
    body.append("url", url);
    body.append("post", post);

    if (!ajaxurl) {
      return;
    }

    fetch(ajaxurl, {
      method: "POST",
      body: body,
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status) {
          loader?.classList.add("wvp-tracking-hidden");

          if (data.status == "success") {
            window.location.reload();
          } else {
            if (data.message) {
              this.handleMessage(data.message);
            }
          }
        }
      });
  }

  handleMessage(message) {
    const div = document.querySelector(".wvp-tracking-edit-message");
    div?.classList.remove("wvp-tracking-edit-message-hidden");

    const element = document.querySelector("#wvp-tracking-message");
    if (element) {
      element.innerHTML = message;
    }
  }
}
